import { RootState } from './rootReducer';

export const IDLE_TIMEOUT: number = 900000; //15 mins

const TOKEN_EXPIRED_ACTION = 'SessionManager/setTokenExpired';
const LAST_ACTIVE_TIME_ACTION = 'SessionManager/setLastActiveTime';

export const sessionMiddleware = (store) => (next) => (action) => {
  const actionTypeObject = typeof action === 'object';
  const payload = action.payload;
  const payloadTypeObject = typeof action.payload === 'object';
  if (
    actionTypeObject &&
    payload !== undefined &&
    payloadTypeObject &&
    Object.prototype.hasOwnProperty.call(payload, 'tokenExpired') &&
    payload['tokenExpired'] === true
  ) {
    const newAction = {
      type: TOKEN_EXPIRED_ACTION,
      payload: undefined,
    };
    next(newAction);
  } else {
    //setLastActiveTime
    const newAction = {
      type: LAST_ACTIVE_TIME_ACTION,
      payload: undefined,
    };
    next(newAction);
    next(action);
  }
};
export const idleTimeMiddleware = (store: any) => (next) => (action) => {
  const state: RootState = store.getState();
  const lastActiveTime: Date = state?.sessionManager.lastActiveTime;
  if (lastActiveTime) {
    if (isSessionExpired(lastActiveTime)) {
      const newAction = {
        type: 'SessionManager/setTokenExpired',
        payload: undefined,
      };
      next(action);
      next(newAction);
    } else {
      next(action);
    }
  } else {
    next(action);
  }
};

export const isSessionExpired = (lastActiveTime: Date): boolean => {
  const currTime = new Date();
  let timeDiff: number = currTime.getTime() - lastActiveTime.getTime();
  return timeDiff > IDLE_TIMEOUT ? true : false;
};
